import {I18n} from "react-redux-i18n";

const visitsSearchFields = (searchFieldValues, buildingList) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "visitorName",
                label: I18n.t("visits.searchFields.visitorName"),
                type: "text",
                value: searchFieldValues.visitorName.value,
            }, {
                id: "visitHost",
                label: I18n.t("visits.searchFields.userEmail"),
                type: "text",
                value: searchFieldValues.visitHost.value,
            }, {
                id: "buildingId",
                label: I18n.t("visits.searchFields.building"),
                type: "dropdown",
                value: searchFieldValues.buildingId.value,
                data: buildingList
            }]
        }]
    }
};

const plannedOrHistoricVisitsSearchFields = (searchFieldValues, buildingList) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "visitorName",
                label: I18n.t("visits.searchFields.visitorName"),
                type: "text",
                value: searchFieldValues.visitorName.value,
            }, {
                id: "visitHost",
                label: I18n.t("visits.searchFields.userEmail"),
                type: "text",
                value: searchFieldValues.visitHost.value,
            }, {
                id: "buildingId",
                label: I18n.t("visits.searchFields.building"),
                type: "dropdown",
                value: searchFieldValues.buildingId.value,
                data: buildingList
            }]
        }]
    }
};


export {
    visitsSearchFields,
    plannedOrHistoricVisitsSearchFields
}